import moment from 'moment';
import classnames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ToolTipPopper } from 'components';

import { FiEye, FiEyeOff } from 'react-icons/fi';

class Input extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: this.props.type === 'date' && this.props.initialValue ? moment(this.props.initialValue) : null,
      calendarFocused: false,
      showPassword: false,
    };
  }

  onDateChange = (name, date) => {
    if (date && date._d) {
      const changedDate = new Date(date._d).toISOString();
      const [dateOnly] = changedDate.split('T');

      this.setState(() => ({ date }));

      this.props.onInputFieldChange(name, dateOnly);
    }
  };

  setPasswordVisibility = showPassword => {
    this.setState({
      showPassword,
    });
  };

  render() {
    const {
      labelText,
      required,
      requiredMark,
      placeholder,
      error,
      disabled,
      type,
      id,
      name,
      helptext,
      small,
      leftPad,
      leftText,
      isLoading,
      onFocus,
      toolTipDetails,
      insideModal,
      typeIndicator,
    } = this.props;

    let inputView = (
      <div className="position-relative">
        {leftText && <span className="lf-input-lefttext">{leftText}</span>}
        <input
          id={id}
          key={id}
          name={name}
          type="text"
          placeholder={placeholder}
          className={classnames(
            'lf-input',
            { [`lf-input--disabled`]: disabled },
            { [`lf-input--error`]: error },
            { [`lf-input--small`]: small },
            { [`lf-input--leftpadding`]: leftPad || leftText }
          )}
          onChange={this.props.onChange}
          required={required ? true : false}
          disabled={disabled}
          onBlur={this.props.onBlur}
          value={this.props.initialValue}
          onFocus={onFocus}
        />
        {isLoading && (
          <div className="icon-container">
            <i className="loader"></i>
          </div>
        )}
        {!error && typeIndicator && (
          <div className="icon-container">
            <span className="lf-color-text-muted">{typeIndicator}</span>
          </div>
        )}
      </div>
    );

    if (type && type === 'password') {
      inputView = (
        <div className={classnames('lf-password-wrapper', { 'lf-password-error': error })}>
          <input
            id={id}
            key={id}
            name={name}
            type={this.state.showPassword ? 'text' : 'password'}
            placeholder={placeholder}
            className={classnames('lf-input', { [`lf-input--disabled`]: disabled }, { [`lf-input--error`]: error })}
            onChange={this.props.onChange}
            required={required ? true : false}
            disabled={disabled}
            onBlur={this.props.onBlur}
            value={this.props.initialValue}
          />
          {this.props.passwordToggle && (
            <button
              type="button"
              className="password-eye-icon cursor-pointer lf-color-grey-60"
              onClick={() => this.setPasswordVisibility(!this.state.showPassword)}
            >
              {this.state.showPassword ? <FiEye /> : <FiEyeOff />}
            </button>
          )}
        </div>
      );
    }

    return (
      <div className={small ? 'lf-input-wrap__small' : insideModal ? 'lf-input-wrap__modal' : 'lf-input-wrap'}>
        <div style={{ display: 'flex' }}>
          <label htmlFor={id} className={`lf-input__label ${required || requiredMark ? 'required' : ''}`}>
            {labelText}
          </label>
          {toolTipDetails || toolTipDetails === '' ? (
            <ToolTipPopper placement="top-start" trigger="click" tooltip={toolTipDetails} />
          ) : (
            ''
          )}
        </div>
        {inputView}
        <span className="lf-input__helptext">{helptext}</span>
        {error && <p className="lf-input__helper">{error}</p>}
      </div>
    );
  }
}

Input.propTypes = {
  labelText: PropTypes.string,
  required: PropTypes.bool,
  requiredMark: PropTypes.bool,
  placeholder: PropTypes.string,
  error: PropTypes.any,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  helptext: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  initialValue: PropTypes.any,
  onInputFieldChange: PropTypes.func,
  passwordToggle: PropTypes.bool,
  isLoading: PropTypes.bool,
  onFocus: PropTypes.func,
  small: PropTypes.bool,
  leftPad: PropTypes.bool,
  leftText: PropTypes.string,
  toolTipDetails: PropTypes.string,
  insideModal: PropTypes.bool,
  typeIndicator: PropTypes.string,
};

Input.defaultProps = {
  isLoading: false,
  onFocus: () => {},
};

export default Input;
